/* eslint-disable indent */
import qs from 'query-string';
import { merge } from 'lodash-es';
import { isBrowser, getWindow } from '@cap/ssr-common-utils';
import {
  DefaultCustom,
  DefalutValLab,
  InitConfig,
  reportLxCoreParams,
  PageViewParam,
  ModuleClickParam,
  ModuleViewParam,
} from './types';
import { logger } from '../logger';
import { loginNewWrapper } from '../loginWrapper/loginNew';
import { getLxCUUID } from './helpers';
import { ACCOUNT_TYPE } from '../../constants';
import { isOnlyProdEnv } from '../runtimeEnv';

export * from './types';

export class Lx {
  defaultCustom: DefaultCustom = {};

  defaultValLab: DefalutValLab = {};

  accountType: number = ACCOUNT_TYPE.PASSPORT;

  isReport = false;

  initLx(config: InitConfig) {
    const window = getWindow();
    const { defaultCustom, defaultValLab, env, accountType } = config;
    this.defaultCustom = defaultCustom;
    this.defaultValLab = defaultValLab;
    this.accountType = accountType;
    // 线上环境或灵犀验证时上报lx,
    const { __lxvalidation } = qs.parse(window.location.search);
    this.isReport = isOnlyProdEnv(env) || !!__lxvalidation;
    // node 端和无头浏览器不上报lx
    if (!isBrowser || navigator.userAgent.indexOf('HeadlessChrome') > -1) {
      this.isReport = false;
    }
  }

  moduleView(param: ModuleViewParam) {
    this.reportLxCore({
      action: 'moduleView',
      param,
    });
  }

  pageView(param: PageViewParam) {
    this.reportLxCore({
      action: 'pageView',
      param,
    });
  }

  moduleClick(param: ModuleClickParam) {
    this.reportLxCore({
      action: 'moduleClick',
      param,
    });
  }

  reportLxCore(config: reportLxCoreParams) {
    const { action, param } = config;
    try {
      const { cid, bid, custom, options, env: lxEnv, valLab: fromValLab } = (param || {}) as any;

      const userInfo = loginNewWrapper.getUserInfoSync();

      /** @see https://docs.sankuai.com/lx/web/extensions/ */
      const valLab: any = {
        ...this.defaultValLab,
        ...fromValLab,
        custom: {
          user_id: userInfo?.userId,
          account_type: this.accountType,
          ...this.defaultCustom,
          ...custom,
        },
      };
      const window = getWindow();
      const { LXAnalytics } = window as any;

      /** @see https://docs.sankuai.com/lx/web/#api */
      if (this.isReport && LXAnalytics) {
        switch (action) {
          case 'pageView':
            LXAnalytics('pageView', valLab, lxEnv || null, cid);
            break;
          case 'moduleClick':
            LXAnalytics('moduleClick', bid, valLab, {
              ...options,
            });
            break;
          case 'moduleView':
            LXAnalytics('moduleView', bid, valLab, {
              ...options,
            });
            break;
          default:
            break;
        }
      } else {
        const id = cid || bid;
        // 打印出埋点数据
        logger.log(`${action}:${id}`, JSON.stringify(valLab));
      }
    } catch (error) {
      logger.warn(error as Error);
    }
  }

  /**
   * 获取帮助中心端uuid，无uuid参考灵犀算法生成
   * 参考：https://docs.sankuai.com/lx/web/uuid/
   */
  getLxCUUID() {
    return getLxCUUID();
  }

  mvDelayLeave(func: () => void) {
    const window = getWindow();
    const { LXAnalytics } = window as any;
    if (LXAnalytics) {
      setTimeout(func, 50);
    } else {
      func();
    }
  }

  setDefaultCustom(options: { [key: string]: string | Array<string> } = {}) {
    this.defaultCustom = merge(this.defaultCustom, options);
  }
}

export const lx: Lx = new Lx();
